import React, { Component } from "react";
import Store from "../../content/Store";
import Content from "../../content/Content";
import { Paths, Urls } from "../../constants/UrlConstants";
import { EPDomain_ROOT } from "../../constants/EP-config";
import EPQueryParams from "../../constants/EPQueryParams";
import { connect } from "react-redux";
import TabNavWithHeader from "../shared/navigation/TabNavWithHeader";
import styles from "../../assets/css/modules/myprofile/myprofile.css";
import { Link } from "react-router-dom";
import MemberHelper from "../../helpers/MemberHelper";
import { SortCodeFormatter,mask } from "../../helpers/SortCodeFormatter";
import ChangeAddressService from "../../services/ChangeAddressService";
import DateHelper from "../../helpers/DateHelper";
import ProfileCardWrapper from "../myprofile/ProfileCardWrapper";
import HelpSection from "../shared/HelpSection";
import PromoImageCard from "../../components/shared/PromoImageCard";
import TelephoneNumberRequired from "../shared/TelephoneNumberRequired";
import { MyProfileChangeIndicator } from "../../constants/Constants";
import AddressHelper from "../../helpers/AddressHelper";
import Button from "../shared/buttons/Button";
import ShadowedContainer from "../shared/containers/ShadowedContainer";
import contentify from "../../content/Contentify";
import {
  ChangeB2CPassword,
  ChangeB2CUsername
} from "../../helpers/AccountsHelper";
import { setMemberDetailUpdated } from "../../actions/account/accountActions";
import { getLayout } from "../../layout/Layout";
import { Layouts } from "../../constants/Constants";
import CrestDowntimeNotification from "./CrestDowntimeNotification";

const getTelephoneNumbers = function (telephones, format1) {
  if (telephones) {
    if (telephones.length === 0) {
      return [Store.MyProfile.MemberPhone.NoNumberHeld];
    }
    if (format1) {
      return [telephones[0].Number];
    }

    return telephones.map((telephone) => (

      <React.Fragment>
        <span id={telephone.PhoneNumberType}>
          <strong>{telephone.PhoneNumberType}</strong>{" "}
          {telephone.Number || Store.MyProfile.MemberPhone.NoNumberHeld}
        </span>
      </React.Fragment>
    ));
  }
  return [Store.MyProfile.MemberPhone.NoNumberHeld];
};


const getMemberBankDetails = function (bankdetails, IsOverageDependant,policyReducer) {
  const tooltip = "icon-info";
  const IsInternalView= policyReducer &&
  policyReducer.policyDetails &&
  policyReducer.policyDetails.IsInternalView;


  if (bankdetails) {
    if (!bankdetails.SortCode) {
      return <React.Fragment><div className={styles.NoDetailsHeld}>

        <i className={tooltip + " " + styles.cardIcon} />{" "}
        <span >{IsOverageDependant?Store.MyProfile.MemberBank?.NoAccountLinkedOA: Store.MyProfile.MemberBank?.NoAccountLinked}</span>

      </div></React.Fragment>;
    }
    return <React.Fragment>
      <div className={styles.memberBankSection}>
        <ul className="list-unstyled membership-meta">
          <li>
            <span className="label">
              <strong>{Store.ChangeBankDetailsInLine.AccountNameTitle}</strong>

            </span>{""}
          </li>
          <li>
            <span className="value axa-mask">
              {IsInternalView ? mask(bankdetails?.AccountHolderName,1):bankdetails?.AccountHolderName}
            </span>
          </li>
          <li>
            <span className="label">
              <strong>{Store.ChangeBankDetailsInLine.AccountNoTitle}</strong>
            </span>{""}
          </li>
          <li>
            <span className="value axa-mask">
              {IsInternalView ? mask(bankdetails?.AccountNumber):bankdetails?.AccountNumber}
            </span>
          </li>
          <li>
            <span className="label">
              <strong>{Store.ChangeBankDetailsInLine.SortCodeTitle}</strong>
            </span>{""}
          </li>
          <li>
            <span className="value axa-mask">
              {IsInternalView?mask(bankdetails?.SortCode,2) :SortCodeFormatter(bankdetails?.SortCode)}
            </span>
          </li>
        </ul>
      </div>
    </React.Fragment>;
  }
  return <React.Fragment><div className={styles.NoDetailsHeld}>
    <i className={tooltip + " " + styles.cardIcon} />{" "}
    <span >{IsOverageDependant?Store.MyProfile.MemberBank?.NoAccountLinkedOA: Store.MyProfile.MemberBank?.NoAccountLinked}</span>
  </div></React.Fragment>;

};

export const mapStateToMyProfile = (state) => {
  const { policyReducer, accountReducer } = { ...state };

  const selectedPolicy = policyReducer && policyReducer.selectedPolicy;
  const currentMember = MemberHelper.getCurrentLoggedInMemberFromPolicy(
    selectedPolicy
  );


  const redirectUrl = AddressHelper.getChangeAddressLink(selectedPolicy);

  return {
    MembershipNumber: selectedPolicy && selectedPolicy.MembershipNumber,
    NoOfPolicies:
      policyReducer &&
      policyReducer.policyDetails &&
      policyReducer.policyDetails.Policies &&
      policyReducer.policyDetails.Policies.length,
    IsInternational: selectedPolicy && selectedPolicy.IsInternational,
    IsInternalView:
      policyReducer &&
      policyReducer.policyDetails &&
      policyReducer.policyDetails.IsInternalView,
    IsSaga: selectedPolicy && selectedPolicy.IsSaga,
    IsIndividual: selectedPolicy && selectedPolicy.IsIndividual,
    IsSME: selectedPolicy && selectedPolicy.IsSME,
    IsLargeCorporate: selectedPolicy && selectedPolicy.IsLargeCorporate,
    Name: currentMember.FullName,
    DateOfBirth: DateHelper.getDateInStringFormat(currentMember.DateOfBirth),
    IsOverageDependant: currentMember.IsOverageDependant,
    IsChildOnlyPolicy : selectedPolicy?.IsChildOnlyPolicy,
    IsPolicyHolder: currentMember.IsPolicyHolder,
    MemberAddress: AddressHelper.getAddressAsStringArray(
      currentMember.Address,
      selectedPolicy && selectedPolicy.IsFormat2
    ),
    MemberPhone: getTelephoneNumbers(
      currentMember.PhoneNumbers,
      selectedPolicy && !selectedPolicy.IsFormat2
    ),
    MemberBank: getMemberBankDetails(currentMember.MemberBankDetail, currentMember.IsOverageDependant, policyReducer),
    MemberBankDetail: currentMember.MemberBankDetail,
    MemberEmail:
      policyReducer &&
      policyReducer.policyDetails &&
      policyReducer.policyDetails.UserName,
    IsLapsed: selectedPolicy && selectedPolicy.IsLapsed,
    PersonConsent: selectedPolicy && selectedPolicy.PersonConsent,
    IsFormat2: selectedPolicy && selectedPolicy.IsFormat2,
    RedirectUrl: redirectUrl,
    IsSMEModular: selectedPolicy && selectedPolicy.IsSMEModular,
    IsHealthSelect: selectedPolicy && selectedPolicy.IsHealthSelect,
    memberDetailUpdated:
      accountReducer && state.accountReducer.memberDetailUpdated,
    featureFlagEP: state && state.unreadMessagesReducer && state.unreadMessagesReducer.featureFlagEP,

  };
};

export const renderInfo = (info) => {
  let renderedJsx = info.map((line, index) => (
    <React.Fragment key={index}>
      {line}
      <br />
    </React.Fragment>
  ));

  return renderedJsx;
};

export class MyProfile extends Component {

  constructor(props) {
    super(props);

    let changeIndicator =
      this.props.history &&
      this.props.history.location &&
      this.props.history.location.state &&
      this.props.history.location.state.changeIndicator;

    this.IsUpdated = {
      memberAddress: changeIndicator === MyProfileChangeIndicator.Address,
      memberPhone: changeIndicator === MyProfileChangeIndicator.Phone,
      memberBank: changeIndicator === MyProfileChangeIndicator.Bank,

      memberEmail: this.hasMemberDetailUpdated(
        changeIndicator,
        MyProfileChangeIndicator.EmailAddress
      ),
      memberPassword: this.hasMemberDetailUpdated(
        changeIndicator,
        MyProfileChangeIndicator.Password
      )
    };
    this.state = {
      url: Urls.EngagementPortal[EPDomain_ROOT].new,
      isCrestDowntime: false,
    };

    this.onClick = this.onClick.bind(this);
  }

  static content = Store.MyProfile;

  componentWillUnmount() {
    this.props.setMemberDetailUpdated(
      Object.assign({}, this.props.memberDetailUpdated, {
        shouldHidePolicyUpdate: true
      })
    );
  }
  componentDidMount() {
    if (this.props.IsFormat2) {
      new ChangeAddressService()
        .GetServiceStatus()
        .catch(() => {
          this.setState({ isCrestDowntime: true });
        });
    }
  }

  hasMemberDetailUpdated(changeIndicator, memberDetail) {
    if (this.props.memberDetailUpdated) {
      return (
        memberDetail === this.props.memberDetailUpdated.memberDetailUpdated
      );
    } else {
      return changeIndicator === memberDetail;
    }
  }


  onClick() {
    this.props.history.push(Paths.AddAPlan);
  }

  handleCallback = (data) => {
    this.setState({ url: data });
  }

  render() {

    const hidePolicyUpdate =
      this.props.memberDetailUpdated &&
      this.props.memberDetailUpdated.shouldHidePolicyUpdate;

    const memberPasswordChangeProps = {
      iconSrc: "icon-functional-padlock",
      title: Store.MyProfile.MemberPassword.Title,
      linkText: Store.MyProfile.MemberPassword.LinkText,
      info: renderInfo([Store.MyProfile.MemberPassword.DefaultPasswordText]),
      isDisabled: this.props.IsInternalView
    };

    const memberEmailChangeProps = {
      iconSrc: "icon-functional-email",
      title: Store.MyProfile.MemberEmail.Title,
      linkText: Store.MyProfile.MemberEmail.LinkText,
      info: renderInfo([this.props.MemberEmail]),
      isMyprofile:true
    };

    if (!hidePolicyUpdate) {
      memberPasswordChangeProps.isUpdated = this.IsUpdated.memberPassword;
      memberEmailChangeProps.isUpdated = this.IsUpdated.memberEmail;
    }

    memberPasswordChangeProps.linkMethod = ChangeB2CPassword;
    memberEmailChangeProps.linkMethod = ChangeB2CUsername;

    if (!this.props.IsOverageDependant) {
      memberEmailChangeProps.isDisabled = this.props.IsInternalView;
    }

    let helpSetContent;
    if(this.props.featureFlagEP === true)
    {
      this.props.IsIndividual ? (helpSetContent = this.props.content.HelpSection.HelpSetEPIND(this.state.url, this.props.IsInternalView)) : (
        helpSetContent = this.props.content.HelpSection.HelpSetEP(this.state.url, this.props.IsInternalView));
    }
      else{
        helpSetContent = this.props.content.HelpSection.HelpSetForHarpa;
        if (this.props.IsSMEModular) {
          helpSetContent = this.props.content.HelpSection.HelpSetForSMEModular;
        } else if (this.props.IsInternational) {
          helpSetContent = this.props.content.HelpSection.HelpSetForInternational;
        }
      }

    return (
      <div className={styles.myProfile}>
        <TabNavWithHeader
          heading={Store.MyProfileHeader.Heading}
          links={
            this.props.IsLapsed && !this.props.PersonConsent
              ? this.props.IsInternational || this.props.IsSaga
                ? Store.MyProfileHeader.LinkWithoutPermissionsOrPrefs
                : Store.MyProfileHeader.LinksWithoutPreferences
              : this.props.IsInternational || this.props.IsSaga
                ? Store.MyProfileHeader.LinksWithoutPermissions
                : Store.MyProfileHeader.Links
          }
          currentLinkIndex={0}
          backgroundColourClass={styles.backgroundColourClass}
        />
        <ShadowedContainer>
          <div className={styles.myProfileContainer}>
            <div className="row">
              <div className="col-12">
                <h2>
                  <Content name={Store.MyProfile.ProfileDetailsHeader} />
                </h2>
              </div>
            </div>
            <div className="row">
              <div className={"col-md-12 " + styles.padDetails}>
                <div className={"col-md-6 " + styles.floatLeft}>
                  <p>
                    <Content name={Store.MyProfile.ProfileDetailsDesc} />
                  </p>
                </div>

                <div className={"col-md-5 offset-md-1 " + styles.memberDetails}>
                  <ul className={styles.profileDetailsHeaderList}>
                    <li>
                      <i className="icon-man-blue" />{" "}
                      <span>
                        <Content name={Store.MyProfile.MemberName} />
                      </span>{" "}
                      <strong>{this.props.Name}</strong>
                    </li>
                    <li>
                      <i className="icon-calendar-blue" />{" "}
                      <span>
                        <Content name={Store.MyProfile.MemberDateOfBirth} />
                      </span>{" "}
                      <strong>{this.props.DateOfBirth}</strong>
                    </li>
                    {this.props.IsInternational ? null : (
                      <li id="numberOfPlans">
                        <i className="icon-newspaper-blue" />{" "}
                        <span>
                          <Content name={Store.MyProfile.NumberOfPlans} />
                        </span>{" "}
                        <strong>{this.props.NoOfPolicies}</strong>
                      </li>
                    )}
                  </ul>
                </div>

                <div
                  className={
                    "col-md-10 col-lg-10 col-xl-6 " +
                    styles.floatLeft +
                    " " +
                    styles.btnWidth
                  }
                >
                  {this.props.IsInternational ? null : (
                    <p className={styles.currentPlan}>
                      <Content name={Store.MyProfile.CurrentPolicy} />:{" "}
                      <strong>{this.props.MembershipNumber}</strong>
                    </p>
                  )}
                  {this.props.NoOfPolicies > 1 &&
                    !this.props.IsInternational ? (
                    <Link
                      to={Paths.ChooseYourPlan}
                      id="btnViewOtherPlans"
                      className={
                        styles.actionButton + " " + styles.actionButtonPrimary
                      }
                    >
                      <Content name={Store.MyProfile.ButtonViewOtherPlans} />
                    </Link>
                  ) : null}
                  {this.props.IsInternational ? null : (
                    <span
                      id="btnAddaPlan"
                      className={styles.secondaryBlueButton}
                    >
                      <Button
                        buttonType="secondaryBlueButton"
                        label={
                          <Content name={Store.MyProfile.ButtonAddAPlan} />
                        }
                        onClick={this.onClick}
                      />
                    </span>
                  )}
                </div>
              </div>
            </div>
            <EPQueryParams url={this.state.url} messageType="changeDetails" updatedURL={this.handleCallback} />
            <div
              className={
                "row align-items-stretch " + styles.profileCardsSection
              }
            >
              <div className="col-12 hidden-md-up">
                <div className={styles.contactDetailsHeading}>
                  <h2>
                    <Content name={Store.MyProfile.ContactDetailsHeading} />
                  </h2>
                </div>
              </div>
              {this.props.IsOverageDependant ? (
                <div id="memberEmail" className="col-sm-6">
                  <ProfileCardWrapper {...memberEmailChangeProps} />
                </div>
              ) : (
                <div id="memberAddress" className="col-sm-6">
                  <ProfileCardWrapper
                    iconSrc="icon-functional-inbox"
                    title={Store.MyProfile.MemberAddress.Title}
                    linkTo={this.props.featureFlagEP === true && (!this.props.IsFormat2 || this.props.IsHealthSelect) ? this.state.url : this.props.RedirectUrl}
                    linkText={Store.MyProfile.MemberAddress.LinkText}
                    info={renderInfo(this.props.MemberAddress)}
                    isUpdated={this.IsUpdated.memberAddress}
                    featureFlagEP={this.props.featureFlagEP}
                    IsFormat2={this.props.IsFormat2}
                    IsHealthSelect={this.props.IsHealthSelect}
                    isDisabled={this.props.IsInternalView}
                    isMyprofile={true}
                  />
                </div>
              )}
              <div
                id="memberPhone"
                className={"col-sm-6 " + styles.memberPhone}
              >
                <TelephoneNumberRequired isTelephoneNumberRequired>
                  <ProfileCardWrapper
                    iconSrc="icon-functional-phone"
                    title={Store.MyProfile.MemberPhone.Title}
                    linkTo={
                      this.props.IsFormat2
                        ? Store.MyProfile.MemberPhone.LinkTo
                        : this.props.featureFlagEP === true
                          ? this.state.url
                          : Store.MyProfile.MemberPhone.LinkToFormat1
                    }
                    linkText={Store.MyProfile.MemberPhone.LinkText}
                    info={renderInfo(this.props.MemberPhone)}
                    isUpdated={this.IsUpdated.memberPhone}
                    featureFlagEP={this.props.featureFlagEP}
                    IsFormat2={this.props.IsFormat2}
                    isDisabled={this.props.IsInternalView}
                    MFATitle={Store.MyProfile.MemberPhone.MFATitle}
                    MFAText={Store.MyProfile.MemberPhone.MFAText}
                  />
                </TelephoneNumberRequired>
              </div>

              {!this.props.IsOverageDependant ? (
                <div id="memberEmail" className="col-sm-6">
                  <ProfileCardWrapper {...memberEmailChangeProps} />
                </div>
              ) : null}

              <div id="memberPassword" className="col-sm-6">
                <ProfileCardWrapper {...memberPasswordChangeProps} />
              </div>
              {/* {this.props.IsOverageDependant || this.props.IsIndividual||( !this.props.IsChildOnlyPolicy && this.props.IsPolicyHolder) || this.props.isSME || this.props.IsLargeCorporate  ? ( */}
                
                {!this.props.IsChildOnlyPolicy  ?(
                <div id="memberBank" className={this.props.IsOverageDependant ?"col-sm-12":"col-sm-6"}>
                  <ProfileCardWrapper
                    iconSrc="icon-lifesavings-coins-pound"
                    title={Store.MyProfile.MemberBank.Title}
                    subTitle={this.props.IsOverageDependant ?Store.MyProfile.MemberBank.SubTitleOA : (this.props.MemberBankDetail?.AccountNumber?Store.MyProfile.MemberBank.SubTitleWithData:Store.MyProfile.MemberBank.SubTitleNA)}
                    InfoText={true}
                    linkTo={this.state.isCrestDowntime === true ? this.state.url : Paths.ChangeBankDetails}
                    isCrestDowntime={this.state.isCrestDowntime}
                    linkText={!this.props.MemberBankDetail?.AccountNumber ? Store.MyProfile.MemberBank.LinkTextAdd : Store.MyProfile.MemberBank.LinkTextUpdate}
                    info={this.state.isCrestDowntime === true ? <CrestDowntimeNotification /> : this.props.MemberBank}
                    isUpdated={this.IsUpdated.memberBank}
                    featureFlagEP={this.props.featureFlagEP}
                    IsFormat2={this.props.IsFormat2}
                    IsOverageDependant={this.props.IsOverageDependant}
                    isDisabled={this.props.IsInternalView||this.state.isCrestDowntime}
                    id={!this.props.MemberBankDetail?.AccountNumber ? Store.MyProfile.MemberBank.idAdd : Store.MyProfile.MemberBank.idChange} 
                  />
                </div>
              ) : null}

            </div>


            <div className="row">
              <div className="col-12">
                <div className={styles.helpSection}>
                  <HelpSection
                    HeadingLinkText={
                      Store.MyProfile.HelpSection.HeadingLinkText
                    }
                    HeadingLinkTo={Store.MyProfile.HelpSection.HeadingLinkTo}
                    MoreHelpLinkText={
                      Store.MyProfile.HelpSection.MoreHelpLinkText
                    }
                    MoreHelpLinkTo={Store.MyProfile.HelpSection.MoreHelpLinkTo}
                    HelpSet={helpSetContent}
                  />
                </div>
              </div>
            </div>
          </div>
        </ShadowedContainer>
        {this.props.IsInternational ? null : (
          <div className={"home " + styles.healthStore}>
            <div className="container">
              <div className="row">
                <div className="col-sm-12">
                  <PromoImageCard
                    ImgSrc={Store.PromoCards.AccessHealthSupportSrc.IconSrc}
                    ImgSrcMobile={
                      Store.PromoCards.AccessHealthSupportSrc.IconSrcMobile
                    }
                    Heading={Store.PromoCards.AccessHealthSupportSrc.Heading}
                    Description={
                      Store.PromoCards.AccessHealthSupportSrc.Description
                    }
                    LinkText={Store.PromoCards.AccessHealthSupportSrc.LinkText}
                    LinkTo={getLayout()===Layouts.HOL ?  Store.PromoCards.AccessHealthSupportSrc.LinkToHOL : Store.PromoCards.AccessHealthSupportSrc.LinkTo}
                    LeftImage
                  />
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default connect(mapStateToMyProfile, { setMemberDetailUpdated })(
  contentify(MyProfile)
);
